import styled from 'styled-components';
import CustomBlockButton from '../../../../../components/button/CustomBlockButton';
import { FormControlLabel, Switch } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelectedCollectedOrderDataValueContextHook } from '../../contexts/SelectedCollectedOrderDataContext';
import { customToast } from '../../../../../components/toast/custom-react-toastify/v1';
import { MapperUtils } from '../../utils/MapperUtils';
import { SellertoolSignatureUtils } from '../../../../../utils/sellertool-signature-utils';
import { useApiInfoContextValueHook } from '../../../../../contexts/ApiInfoContext';
import { TemporaryErpItemApi } from '../../../../../apis/TemporaryErpItemApi';
import { CustomBackdropController } from '../../../../../components/backdrop/default/v1';
import { ModalTemporaryErpItemsTable } from './modals/modal-temporary-erp-items-table';

const StyledContainer = styled.div`
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const StyledButton = styled(CustomBlockButton)`
    width: 100px;
    height: 40px;
    background-color: #333;
    color:#fff;
    font-weight: 600;
    border-radius: 3px;
    border: none;

    &.temporary{
        background-color: #fff;
        border: 1px solid #e0e0e0;
        color: #333;
        width: 130px;

        .count{
            /* float: right; */
            background-color: #6c757d;
            color: white;
            border-radius: 12px;
            padding: 2px 8px;
            font-size: 12px;
            font-weight: 600;
        }
    }
`;

export function WegetCollectedTopButtons(props) {
    const [confirmOrderFlag, setConfirmOrderFlag] = useState(true);
    const selectecCollectedOrderDataValueContextHook = useSelectedCollectedOrderDataValueContextHook();

    const apiInfoContextValueHook = useApiInfoContextValueHook();

    const [temporaryErpItemList, setTemporaryErpItemList] = useState([]);
    const [temporaryErpItemsModalOpen, setTemporaryErpItemsModalOpen] = useState(false);

    useEffect(() => {
        if (!apiInfoContextValueHook?.apiInfo?.apiKey || !apiInfoContextValueHook?.apiInfo?.secretKey) {
            return;
        }

        handleReqFetchTemporaryErpItemList();
    }, [apiInfoContextValueHook?.apiInfo?.apiKey, apiInfoContextValueHook?.apiInfo?.secretKey]);

    const handleReqFetchTemporaryErpItemList = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const fetchResult = await TemporaryErpItemApi().searchList({ headers: headers })

        if (fetchResult?.content) {
            setTemporaryErpItemList(fetchResult?.content);
        }
    }

    const handleSave = async () => {
        if (!selectecCollectedOrderDataValueContextHook?.selectedCollectedOrderData?.newOrders) {
            customToast.error('스토어를 먼저 선택해 주세요.');
            return;
        }

        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const temporaryErpItemList = MapperUtils().getMappedOrderData({
            orders: selectecCollectedOrderDataValueContextHook?.selectedCollectedOrderData.newOrders,
            salesChannel: selectecCollectedOrderDataValueContextHook?.selectedCollectedOrderData?.commerceApiStoreInfo?.storeName,
            workspaceId: null
        });

        const processConfirmTargetIds = selectecCollectedOrderDataValueContextHook?.selectedCollectedOrderData.newOrders
            ?.filter(r => r?.content?.productOrder?.placeOrderStatus === 'NOT_YET')
            ?.map(r => {
                if (r?.content?.productOrder?.placeOrderStatus === 'NOT_YET') {
                    return r?.content?.productOrder?.productOrderId;
                }
            })
        const body = {
            commerceApiStoreInfo: selectecCollectedOrderDataValueContextHook?.selectedCollectedOrderData?.commerceApiStoreInfo,
            temporaryErpItemList: temporaryErpItemList,
            confirmOrderFlag: confirmOrderFlag,
            processConfirmTargetIds: processConfirmTargetIds,
            collectionMethod: 'COMMERCE_API'
        }

        CustomBackdropController().showBackdrop();
        const apiResult = await TemporaryErpItemApi().createList({ headers: headers, body: body })
        if (apiResult?.content) {
            await handleReqFetchTemporaryErpItemList();
            customToast.success('임시 주문건으로 저장되었습니다.');
        }
        CustomBackdropController().hideBackdrop();
    }

    return (
        <>
            <StyledContainer>
                <StyledButton
                    type='button'
                    onClick={() => handleSave()}
                >
                    저장
                </StyledButton>
                <StyledButton
                    type='button'
                    className='temporary'
                    onClick={() => setTemporaryErpItemsModalOpen(true)}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <div>
                            임시 주문건
                        </div>
                        <div className='count'>{temporaryErpItemList?.length}</div>
                    </div>
                </StyledButton>
                <FormControlLabel control={<Switch checked={confirmOrderFlag} onChange={(e) => setConfirmOrderFlag(e.target.checked)} />} label={<span style={{ fontSize: 14, fontWeight: 600 }}>저장시 발주확인</span>} />
            </StyledContainer>

            {temporaryErpItemsModalOpen &&
                <ModalTemporaryErpItemsTable
                    open={temporaryErpItemsModalOpen}
                    onClose={() => setTemporaryErpItemsModalOpen(false)}
                    temporaryErpItems={temporaryErpItemList}
                    onReqFetchTemporaryErpItems={handleReqFetchTemporaryErpItemList}
                />
            }
        </>
    );
}